import { DayInfo } from "../types/times-module-types";
import {
  getCellClassTodayClickable,
  isClosed,
  isDateValidToEnterTime,
} from "./timesUtils";
import { getDateFromDateString, getDateFromISOFormat } from "../../SharedModule/utils/dateUtils";
import { BAMBOO_HR } from "../../SharedModule/utils/constants";

// ---------------------------------------------------------------------------
// isSubtaskClickable, extracted from TimesPage (ASUITE11-4390, S3776). Pure
// given the caller's role/assignment flags — no dispatch/setState/refs — so
// it's parametrized instead of closing over component state, with no other
// behavior change.
// ---------------------------------------------------------------------------

export type ClickabilityRoles = {
  activeUserId: any;
  actualUserId: any;
  isSuperTimeAdmin: boolean;
  isDeliveryTimeAdmin: boolean;
  isSupervisorOrPO: boolean;
  isTimeViewer: boolean;
  isTimeAdmin: boolean;
  usersAssignees: { value: any }[] | undefined;
};

export const computeIsSubtaskClickable = (
  day: DayInfo,
  avoidCheck: boolean,
  taskStatus: string | null,
  parentStatus: string | null,
  roles: ClickabilityRoles,
  previousWorkableDay: Date,
  lastWorkableDay: Date,
): string => {
  const {
    activeUserId,
    actualUserId,
    isSuperTimeAdmin,
    isDeliveryTimeAdmin,
    isSupervisorOrPO,
    isTimeViewer,
    isTimeAdmin,
    usersAssignees,
  } = roles;

  // if time off => exceptions: meal break and nursing mother
  if (
    (day.isTimeOff &&
      (avoidCheck ? false : activeUserId === actualUserId) &&
      !day.isMealBreakOrNursingMother) ||
    (!isDateValidToEnterTime(
      isSuperTimeAdmin || isDeliveryTimeAdmin,
      isSupervisorOrPO,
      isTimeViewer,
      activeUserId,
      actualUserId,
      getDateFromDateString(day.actualDate),
      previousWorkableDay,
      lastWorkableDay,
      usersAssignees,
    ) &&
      day.hoursWorked === 0) ||
    // ASUITE11-2512: not add time entries if are closed/resolved/inactive/complete/canceled except super admin
    (taskStatus && isClosed(taskStatus) && day.hoursWorked === 0) ||
    (parentStatus && isClosed(parentStatus) && day.hoursWorked === 0) ||
    // ASUITE11-2418: Time Viewer Role - FE
    (!isSuperTimeAdmin &&
      !isDeliveryTimeAdmin &&
      isTimeViewer &&
      day.hoursWorked === 0 &&
      activeUserId !== actualUserId &&
      ((isSupervisorOrPO &&
        !usersAssignees?.find((user) => user.value === actualUserId)) ||
        !isSupervisorOrPO))
  ) {
    return "";
  }
  const actualdate = new Date(getDateFromISOFormat(day.actualDate));

  if (isTimeAdmin && activeUserId !== actualUserId) {
    return getCellClassTodayClickable(day.actualDate);
  } else if (isTimeAdmin) {
    return getCellClassTodayClickable(day.actualDate);
    // exception ASUITE11-2561: normal users allow to see time entries imprted from bamboo disabled
  } else if (
    !isTimeAdmin &&
    day.timeEntries?.length > 0 &&
    day.timeEntries.some((e) => e.source === BAMBOO_HR)
  ) {
    return getCellClassTodayClickable(day.actualDate);
  } else if (actualdate < lastWorkableDay) {
    // timeEntries is null => add, timeEntries is empty array, case when no time entries and subtask are same as last week, timeEntries has info, need to check if some can edit
    if (
      !day.timeEntries ||
      day.timeEntries?.length === 0 ||
      (day.timeEntries?.length > 0 &&
        day.timeEntries.some((e) => e.canEdit)) ||
      (day.timeEntries?.length > 0 &&
        day.timeEntries.some((e) => e.timeEntryStatusId === 1)) // at least one time entry have status "pending"
    ) {
      return getCellClassTodayClickable(day.actualDate);
    } else {
      return "";
    }
  } else {
    return "";
  }
};
